import { __assign, __read } from "tslib";
import React, { useRef, useState, useContext, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Tooltip } from '@keen.io/ui-core';
import { ChartContext } from '../../contexts';
import { calculateTooltipPosition } from './chart-tooltip.utils';
var tooltipMotion = {
    initial: { opacity: 0.5, x: 10 },
    animate: { opacity: 1, x: 0 },
    transition: { duration: 0.2 },
    exit: { opacity: 0, x: 10 },
};
var ChartTooltip = function (_a) {
    var children = _a.children, visible = _a.visible, x = _a.x, y = _a.y, _b = _a.hasSpacing, hasSpacing = _b === void 0 ? true : _b;
    var _c = __read(useState({ width: 0, height: 0 }), 2), foreignObject = _c[0], setForeignObject = _c[1];
    var wrapper = useRef(null);
    var _d = useContext(ChartContext), svgDimensions = _d.svgDimensions, margins = _d.margins, theme = _d.theme;
    useEffect(function () {
        if (wrapper.current) {
            var _a = wrapper.current.getBoundingClientRect(), width = _a.width, height = _a.height;
            setForeignObject({ width: width, height: height });
        }
    }, [visible, x]);
    var _e = calculateTooltipPosition(__assign({ svgDimensions: svgDimensions,
        margins: margins,
        x: x,
        y: y }, foreignObject)), tooltipX = _e.tooltipX, tooltipY = _e.tooltipY, transform = _e.transform, arrowDirection = _e.arrowDirection, arrowTop = _e.arrowTop;
    return (React.createElement(AnimatePresence, null, visible && (React.createElement(motion.foreignObject, __assign({ pointerEvents: "none", style: { overflow: 'visible' }, x: tooltipX, y: tooltipY, width: foreignObject.width, height: foreignObject.height }, tooltipMotion),
        React.createElement("div", { ref: wrapper, style: {
                transform: transform,
                display: 'inline-block',
            } },
            React.createElement(Tooltip, { hasSpacing: hasSpacing, mode: theme.tooltip.mode, arrowDirection: arrowDirection, arrowTop: typeof arrowTop === 'number' && arrowTop + "px" }, children))))));
};
export default ChartTooltip;
